module.exports = {"COP":"CO","ARS":"AR","PEN":"PE"}